module.exports = __webpack_public_path__ + "img/icon-warning-landslide-yellow.5b26d862.svg";